module.exports = __webpack_public_path__ + "static/media/order_icon7.d3c565b7.png";